/* External */
import { useEffect, useState } from 'react';

/* Ott-common */
import { useGetSync } from '@dtvgo/react-utils';
import { useHandlePlayerError } from '@dtvgo/player-utils-react';

/* Utils */
import { useConnectionStatus, useOnDisconnectedMessageHide, useSetShowDisconnectedMessage } from '../../../providers/ConnectionStatusProvider';

export default function useHandlePlayerErrorWithReloadOnConnected() {
  const {
    error, handleError, reportableError, handleReportableError,
  } = useHandlePlayerError();

  const [errorToDisplay, setErrorToDisplay] = useState(undefined);
  const getCurrentError = useGetSync(error);
  const setShowDisconnectedMessage = useSetShowDisconnectedMessage();
  const isConnected = useGetSync(useConnectionStatus().isConnected);

  /* When an error appears on the player, we display the error */
  useEffect(() => {
    if (error) {
      setErrorToDisplay(error);
      // And if we are not connected by that time, we show the disconnected message
      // avoiding the timeout that could be running. (See ConnectionStatusProvider)
      if (!isConnected()) setShowDisconnectedMessage(true);
    }
  }, [error, isConnected, setShowDisconnectedMessage]);

  /* When we are connected again, we hide the error causing the player to reload */
  useOnDisconnectedMessageHide(() => {
    if (getCurrentError()) {
      setErrorToDisplay(undefined);
    }
  });

  return {
    error: errorToDisplay,
    handleError,
    reportableError,
    handleReportableError,
  };
}
